/**
 * Magniberg size picker wrapper (blocks/mb-size-picker.liquid).
 *
 * Variant selection is handled by Horizon's <variant-picker> inside this element. This
 * only handles the two toggles: "Show all sizes" sets the `show-all` attribute, which
 * the block's CSS uses to reveal the non-standard sizes and swap the heading and the
 * buttons; "Show recommended sizes" removes it again. The element carries
 * `data-skip-node-update`, so the state survives re-renders.
 */
class MbSizePicker extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abort;

  connectedCallback() {
    this.#abort = new AbortController();
    this.addEventListener('click', this.#onClick, { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('.mb-size-picker__show-all')) {
      this.setAttribute('show-all', '');
      this.querySelector('input:checked')?.focus();
    } else if (event.target.closest('.mb-size-picker__show-recommended')) {
      this.removeAttribute('show-all');
      this.querySelector('input:checked')?.focus();
    }
  };
}

if (!customElements.get('mb-size-picker')) {
  customElements.define('mb-size-picker', MbSizePicker);
}
